// extracted by mini-css-extract-plugin
module.exports = {"title":"questionAnswers_title__KkAY8","subTitle":"questionAnswers_subTitle__Jse27"};